export const WIZY_SELECT_LARGE_VIDEO_PARTICIPANT = 'WIZY_SELECT_LARGE_VIDEO_PARTICIPANT';
export const WIZY_REMOVE_LARGE_VIDEO_PARTICIPANT = 'WIZY_REMOVE_LARGE_VIDEO_PARTICIPANT';
export const WIZY_PINNED_PARTICIPANT = 'WIZY_PINNED_PARTICIPANT';
export const WIZY_ACTIVE_SPEAKER_ADDED = 'WIZY_ACTIVE_SPEAKER_ADDED';
export const WIZY_ACTIVE_SPEAKER_REMOVED = 'WIZY_ACTIVE_SPEAKER_REMOVED';
